<template>
  <div id="OrgDetailInfo" :class="flagObj.authStatusFlag == true?'autoStatus':''">
    <div v-if="flagObj.authStatusFlag" class="auth-div">
      <div class="auth-div-title">企业信息</div>
      <div class="auth-div-desc">已认证</div>
    </div>
    <eb-panel>
      <eb-panel-header class="panel-header" slot="header">
        <span slot="title" style="display: inline-block;width: 100%;">
          <span style="float: left;width: 22.8%;">企业信息</span>
          <span v-if="orgInfo.departType==1 || orgInfo.departType==3" slot="button" style="color: #fb5b3b;float: left;">{{departRealNameInfo(orgInfo.authStatus)}}</span>
          <RealNameAuthBtn :orgInfo="orgInfo" :user="user" :flagObj="flagObj" :myApprovalInfo="myApprovalInfo"></RealNameAuthBtn>
        </span>
      </eb-panel-header>
      <div slot="body">
        <div class="panel-body-row">
          <div class="panel-body-row-left">统一社会信用代码:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.creditCode" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
            <span style="color:rgb(251, 91, 59);line-height:51px;padding-left:10px;">*必填项</span>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left">企业名称:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.departName" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
            <span style="color:rgb(251, 91, 59);line-height:51px;padding-left:10px;">*必填项</span>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">类型:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.orgType" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">法定代表人:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.legalPerson" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">注册资本:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.registerCapital" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">成立日期:</div>
          <div class="panel-body-row-right">
            <ebOrgDateTimePicker :time.sync="orgInfo.foundingDate" :disabled="flagObj.authInfoStatus" :dateFormat="'yyyy年MM月dd日'" :datePlaceholder="'年-月-日'" :editable="false" :timeOption="false"/>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">营业期限自:</div>
          <div class="panel-body-row-right">
            <ebOrgDateTimePicker :time.sync="orgInfo.busiTermStart" :disabled="flagObj.authInfoStatus" :dateFormat="'yyyy年MM月dd日'" :datePlaceholder="'年-月-日'" :editable="false" :timeOption="false"/>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">营业期限至:</div>
          <div class="panel-body-row-right">
            <el-radio class="eb-radio" @click="checkbusiTermEnd('1')" v-model="flagObj.busiTermEndStatus" :disabled="flagObj.authInfoStatus"  label="1">长期有效</el-radio>
            <el-radio class="eb-radio" @click="checkbusiTermEnd('2')" v-model="flagObj.busiTermEndStatus" :disabled="flagObj.authInfoStatus" label="2" style="margin-right: 20px;">指定日期</el-radio>
            <ebOrgDateTimePicker v-if="flagObj.busiTermEndStatus=='2'" :disabled="flagObj.authInfoStatus" :time.sync="orgInfo.busiTermEnd" :dateFormat="'yyyy年MM月dd日'" :datePlaceholder="'年-月-日'" :editable="false" :timeOption="false"/>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">登记机关:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.regOffice" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">核准日期:</div>
          <div class="panel-body-row-right">
            <ebOrgDateTimePicker :time.sync="orgInfo.approvalDate" :disabled="flagObj.authInfoStatus" :dateFormat="'yyyy年MM月dd日'" :datePlaceholder="'年-月-日'" :editable="false" :timeOption="false"/>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">登记状态:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.regStatus" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">注册地址:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.registerAddress" :disabled="flagObj.authInfoStatus" class="eb-input panel-body-row-right"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">经营范围:</div>
          <div class="panel-body-row-right">
            <el-input v-model="orgInfo.busiScope" :disabled="flagObj.authInfoStatus" class="eb-textarea" type="textarea"></el-input>
          </div>
        </div>
        <div class="panel-body-row">
          <div class="panel-body-row-left projectInfo">营业执照:</div>
          <div class="panel-body-row-right">
            <div id="imgBox1" :data-img-preview-src="getBusinessLicenseImgUrl()" v-image-preview style="display: flex; width: 109px; float: left;align-items: center;">
              <span style="position: relative;align-items: center;">
                <img id="showPic" :src="getBusinessLicenseImgUrl()" style="margin: auto; max-width: 100%; max-height: 100%; width: auto; height: auto; position: relative">
                <img v-show="flagObj.authStatusFlag" :src="$ebConfig.imgPath+'img/authstatus.png'" style="position: absolute; height: 20px; width: 20px; top: 0; left: 0" alt="">
                <el-progress type="circle" :percentage="uploadPercentage" v-show="uploadPercentage != 0 && uploadPercentage != 100" :stroke-width="5" :width="80" style="position: absolute;top: 0;left: 15px"></el-progress>
              </span>
            </div>
            <div style="position: relative; float: left; height: 100px; width: 100px; padding-left: 6px; padding-top: 14px;">
              <i class="iconfont icon-shanchu" style="color: red;cursor: pointer;" v-show="!flagObj.authInfoStatus" @click="confirmDeleteBusi()"></i>
              <el-upload
                style="display: inline;"
                name="myFile"
                :show-file-list="false"
                :action="uploadBusinessLicenseUrl"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-preview="handlePictureCardPreview"
                :on-error="handleAvatarError"
                :on-progress="handleUploadProgress">
                <i v-show="!flagObj.authInfoStatus" slot="trigger" style="cursor: pointer;color: red;" class="icon iconfont icon-ico_pic"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </eb-panel>
  </div>
</template>
<script>
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import RealNameAuthBtn from '@/components/org/realNameAuth/RealNameAuthBtn';
import ebOrgDateTimePicker from '@/components/common/eb-datetime-picker/eb-org-datetime-picker';
import { imagePreview } from '@/directives/image-preview';
import moment from 'moment';
import { deleteBusi } from '@/services/org/depart-service';
import { baseURL } from '@/plugins/axios.js';
import eventBus from '@/plugins/event-bus';
export default {
  name: 'OrgDetailInfo',
  directives: {
    imagePreview: imagePreview
  },
  props: {
    orgInfo: {},
    user: {},
    flagObj: {
      type: Object,
      required: true
    },
    approvalInfo: {}
  },
  components: {
    ebPanel,
    ebPanelHeader,
    RealNameAuthBtn,
    ebOrgDateTimePicker
  },
  data() {
    return {
      myApprovalInfo: this.approvalInfo,
      businessLicenseImgUrl: '',
      businessLicenseImgDialogVisible: true,
      uploadPercentage: 0
    };
  },
  computed: {
    uploadBusinessLicenseUrl: {
      get: function() {
        var date = moment(new Date()).format('YYYYMMDD');
        return baseURL + '/api/departRegister/upload_attachment?channel=org-file&date=' + date + '';
      }
    },
    foundingDate: {
      get: function() {
        return this.$options.filters['dateFormatYMD'](this.orgInfo.foundingDate);
      }
    },
    busiTermStart: {
      get: function() {
        return this.$options.filters['dateFormatYMD'](this.orgInfo.busiTermStart);
      }
    },
    busiTermEnd: {
      get: function() {
        return this.$options.filters['dateFormatYMD'](this.orgInfo.busiTermEnd);
      }
    },
    approvalDate: {
      get: function() {
        return this.$options.filters['dateFormatYMD'](this.orgInfo.approvalDate);
      }
    }
  },
  methods: {
    departRealNameInfo(authStatus) {
      let roleId = this.user.roleid;
      if (authStatus === '1') {
        return this.$options.filters['orgAuthStatus'](this.orgInfo.authStatus);
      } else if (authStatus === '2') {
        return this.$options.filters['orgAuthStatus'](this.orgInfo.authStatus);
      } else {
        if (roleId === 2 || roleId === 8 || roleId === 9) {
          return this.$options.filters['orgAuthStatus'](this.orgInfo.authStatus);
        } else {
          return '未实名认证';
        }
      }
    },
    checkbusiTermEnd(status) {
      this.flagObj.busiTermEndStatus = status;
      if (status === '2') {
        if (moment(this.orgInfo.busiTermEnd).format('YYYY-MM-DD') === '2999-01-01') {
          this.orgInfo.busiTermEnd = new Date();
        }
      }
    },
    getBusinessLicenseImgUrl() {
      return this.orgInfo.businessLicense ? baseURL + this.orgInfo.businessLicense : baseURL + '/static/img/147x147.png';
    },
    confirmDeleteBusi() {
      this.$confirm('是否删除营业执照？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'eb-confirm-button',
        cancelButtonClass: 'eb-confirm-button',
        type: '',
        center: true,
        showClose: false,
        customClass: 'eb-comfirm'
      })
        .then(() => {
          var params = {
            departId: this.user.orgId,
            businessLicense: ''
          };
          this.deleteBusi(params);
        })
        .catch(() => {});
    },
    async deleteBusi(params) {
      let result = await deleteBusi(params);
      result = result.data;
      if (result.returnCode === '01') {
        this.$message.success('删除成功');
        eventBus.$emit('refreshOrgInfo', true);
      }
    },
    async handleAvatarSuccess(res, file) {
      this.orgInfo.businessLicense = res;
      var params = {
        departId: this.user.orgId,
        businessLicense: this.orgInfo.businessLicense
      };
      await deleteBusi(params);
      this.businessLicenseImgUrl = res;
      eventBus.$emit('refreshOrgInfo', true);
    },
    beforeAvatarUpload(file) {
      var reg = /\.tiff$|\.tif$|\.bmp$|\.jpg$|\.jpeg$|\.gif$|\.png$/i;

      if (!reg.test(file.name)) {
        this.$message.error('您上传的文件类型不正确');
        return false;
      }
      if (!this.udFailSize(file)) { // 上传大小限制
        this.$message.error('请上传小于10M的附件');
        return false;
      }
      return true;
    },
    handlePictureCardPreview(file) {
      this.businessLicenseImgUrl = file.url;
      this.businessLicenseImgDialogVisible = true;
    },
    handleUploadProgress(event, file, fileList) {
      let val = (event.loaded / event.total * 100).toFixed(0);
      this.uploadPercentage = parseInt(val);
    },
    handleAvatarError(err, file, fileList) {
      if (err) {
        this.$message.error('文件上传失败');
      }
    },
    udFailSize(el, max) {
      var maxSize = 1024 * 1024 * 10; // 默认10M
      if (max) {
        maxSize = 1024 * 1024 * max;
      }

      var size = el ? el.size : '';
      if (size > maxSize) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style scoped lang="less">
  .eb-textarea {
    height: 171px;
    width: 77.2%;
  }
  .autoStatus{
    background: url("../../../assets/img/autostatus_bg.jpg");
    overflow: hidden;
    border: 1px solid #fb5b3b;
    box-shadow: 5px 5px 5px #ccc;
    position: relative;
  }
  #OrgDetailInfo {
    .auth-div {
      position:absolute;
      right:-52px;
      top:39px;
      height:50px;
      width:234px;
      background:#fb5b3b;
      transform:rotate(45deg);
      .auth-div-title{
        text-align:center;
        color:#fff;
        padding-top:5px;
      }
      .auth-div-desc{
        text-align:center;
        color:#fff;
      }
    }
  }

</style>
